import { Injectable } from '@angular/core';
import { Dictionary } from 'src/app/models/core/dictionary_T';
import { FolderTabInfos } from 'src/app/models/folder-tab-infos';
import { ConnectedUsersStateService } from './connected-users-state.service';

@Injectable({
    providedIn: 'root',
})
export class OpenedFoldersStateService {
    /**
     * Dictionnaire des references des dossiers dont le détail est ouvert.
     */
    public openedFolders: Dictionary<FolderTabInfos> = new Dictionary<FolderTabInfos>();

    constructor(connectedUsersStateService: ConnectedUsersStateService) {
        connectedUsersStateService.onUserConnectedChange$.subscribe((x) => {
            this.openedFolders = new Dictionary<FolderTabInfos>();
        });
    }
}
